import { Box, Button, Divider, Grid, Link, Typography } from '@mui/material'
import React from 'react'
import VendorRFQ from '../../Vendor/VendorCompanyCardComponent/VendorRFQ'
import { useGetCurrentUserInfoQuery } from '../../../store/api/userApi'
import { useTranslation } from 'react-i18next'
import { OndemandVideo } from '@mui/icons-material'
import RetrieveDialog from '../../../components/Dialog/RetrieveDialog'

const RfqInformation = () => {
  const { data: userInfoData } = useGetCurrentUserInfoQuery();
  const { t } = useTranslation("rfq")

  return (
    <div>
      <Grid item xs={12} sx={{ display: 'flex', textAlign: 'center', alignItems: 'center', mt: 1, mb: 2 }}>
        <Typography sx={{ fontWeight: 'bold' }} variant="h5" component="div">
          {t('rfq_information')}
        </Typography>
        <Divider textAlign="left" sx={{ width: '92%' }}></Divider>
      </Grid>

      <Grid item xs={12} sx={{ display: 'flex', textAlign: 'center', alignItems: 'center', mt: 1, mb: 2, gap: '20px' }}>
        <Link href={'https://www.youtube.com/watch?v=G4F_2UskJlM'} target={'_blank'} underline="none">
          <Button variant="contained" startIcon={<OndemandVideo />}>Operation Guide</Button>
        </Link>
        <Link href={'https://www.youtube.com/watch?v=IXYZiHakPGw'} target={'_blank'} underline="none">
          <Button variant="contained" color="secondary" startIcon={<OndemandVideo />}>Əməliyyat Təlimatı</Button>
        </Link>
      </Grid>

      <Box sx={{ height: 600, width: '100%' }}>
        <VendorRFQ vendorCode={userInfoData?.data?.vendorCode} />
        <RetrieveDialog />
        
      </Box>
    </div>
  )
}

export default RfqInformation